import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { headerSolutionsItems } from '../../data/data';
const SolutionsCard = () => {
  const history = useHistory();

  return (
    <>
      {/* <div className="header-dropdown-card-wrapper-arrow-up"></div> */}
      <div className="header-dropdown-card-wrapper ptb--10 plr--10">
        {headerSolutionsItems.map(({ icon, title, url }) => (
          <div
            className="header-dropdown-card-item-wrapper"
            onClick={() => history.push(url)}
            key={url}
          >
            <img src={'/assets/images/' + icon} alt={title} />
            <span
              className={`ptb--5 plr--5 solutions-link-card-item font--16`}
              // style={{
              //   color: 'black',
              // }}
              spellCheck
            >
              <NavLink className="font--16" to={url}>
                {title}
              </NavLink>
            </span>
          </div>
        ))}
      </div>
    </>
  );
};

export default SolutionsCard;
